import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppModalComponent } from './modal.component';

@Injectable({ providedIn: 'root' })
export class AppModalService {
  constructor(public _dialog: MatDialog) {}

  confirm(
    title: string | null,
    content?: string | null,
    callback?: (() => void) | ((result: boolean) => void),
  ) {
    return this.custom(AppModalComponent, { title, content, callback });
  }

  custom(component: any, data: any, config: any = {}) {
    return this._dialog.open(component, {
      data: data,
      ...config,
    });
  }
}
